<template>
  <button :disabled="disabled" class="btn btn-loading">
    {{ name }}
    <div class="loading-spinner" v-if="loading">
      <div class="spin-icon"></div>
    </div>
  </button>
</template>

<script>
export default {
  name: 'UIButton',
  props: {
    name: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'button'
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-loading {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
}
.loading-spinner {
  display: inline;
  margin-left: 9px;
  .spin-icon {
    margin: auto;
    width: 18px;
    height: 18px;
    border: solid 3px transparent;
    border-radius: 80px;
    border-top-color: #fff;
    border-left-color: #fff;
    -webkit-animation: loading-spinner 500ms linear infinite;
    -moz-animation: loading-spinner 500ms linear infinite;
    -ms-animation: loading-spinner 500ms linear infinite;
    -o-animation: loading-spinner 500ms linear infinite;
    animation: loading-spinner 500ms linear infinite;
  }
}
@-webkit-keyframes loading-spinner {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-moz-keyframes loading-spinner {
  0% {
    -moz-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -moz-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-o-keyframes loading-spinner {
  0% {
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-ms-keyframes loading-spinner {
  0% {
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loading-spinner {
  0% {
    transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
